import axios from "axios";
export default {
  async actionGetResults({ commit }, payload) {
    const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/r2`, {params:payload});
    commit("SET_HEADERS", results.data.header);
    commit("SET_RESULTS", results.data.animals);
  }
}